import type { AccountAccessStatus } from '@data/account-access';
import type { PaymentStatus } from '@data/global-api-payments';
import { locationAssign } from '@utility/checkout-utils';
import { COMMON_EVENTS } from '@utility/data-layer';

import { dataLayer } from './dataLayer';

export const redirectOutsideSca = (
  directUrl: string,
  subjectStatus: AccountAccessStatus | PaymentStatus | undefined
) => {
  dataLayer.trackEvent({
    name: COMMON_EVENTS.REDIRECTION,
    properties: {
      redirectType: 'locationAssign',
      redirectTarget: directUrl,
      paymentStatus: subjectStatus,
    },
    options: { transport: 'sendBeacon' },
  });

  locationAssign(directUrl);
};
